/*
 * @Author: songjian
 * @Date: 2023-05-12 11:22:06
 * @Description: 
 * @FilePath: /海通PC/src/main.js
 * @LastEditTime: 2024-12-23 12:15:24
 * @LastEditors: songjian
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import mixin from './mixin'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import alertPlugin from '@/components/alertPlugin/alert'
import confirmPlugin from '@/components/alertPlugin/confirm'
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper)
Vue.use(alertPlugin)
Vue.use(confirmPlugin)
Vue.mixin(mixin)
Vue.config.productionTip = false
window.$alert = Vue.prototype.$alert || {}

import filters from './filters/filters'
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js